module.exports = __webpack_public_path__ + "img/linkedin.8cad565a.svg";